const state = {
  videos: []
}

const mutations = {
  ADD_VIDEO: (state, video) => {
    state.videos.push(video)
  },
  DESTROY_VIDEO: (state, video) => {
    const i = state.videos.indexOf(video)
    if (i != -1) { state.videos.splice(i, 1) }
  },
  DESTROY_ALL: (state) => {
    for (let i = state.videos.length - 1; i >= 0; i--) {
      const video = state.videos[i]
      // for (const video of state.videos) {
      if (video && video.destroy) { video.destroy() }
      // }
    }
  }
}

const actions = {
  addVideo({ commit }, video) { // video自己会销毁，不需要外部调用
    // commit('ADD_VIDEO', video)
  },
  destroyVideo({ commit }, video) { // video自己会销毁，不需要外部调用
    // commit('DESTROY_VIDEO', video)
  },
  destroyAll({ commit }) { // video自己会销毁，不需要外部调用
    // commit('DESTROY_ALL')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/video.js